import { Col, Divider, Row, Space } from "antd";
import { FormInput, FormSelect } from "components/form/FormProvide";
import { useTranslation } from "react-i18next";


const FinancialInformationForEdit = ({ bankOptions = [], }) => {
    const { t } = useTranslation();

    return (
        <Space direction="vertical" size={6} style={{ width: "100%" }}>
            <b style={{ fontSize: "20px" }}>
                {t("company_profile.label.financial_information")}
            </b>
            <Divider />
            <Row gutter={[24, 16]}>
                <Col span={12}>
                    <FormSelect
                        fontWeight="bold"
                        vertical={true}
                        required
                        name="bankAccount"
                        label={
                            t("company_profile.label.bank_account")
                        }
                        placeholder={t('company_profile.label.please_select')}
                        size="large"
                        options={bankOptions}
                    />
                </Col>
                <Col span={12}>
                    <FormInput
                        fontWeight="bold"
                        vertical={true}
                        required
                        name="bankAccountNo"
                        label={
                            t("company_profile.label.bank_account_no")
                        }
                        placeholder={t('company_profile.label.bank_account_no')}
                        size="large"
                    />
                </Col>
                <Col span={12}>
                    <FormInput
                        fontWeight="bold"
                        vertical={true}
                        name="bankReferenceCode"
                        label={
                            t("company_profile.label.bank_company_code")
                        }
                        placeholder={t('company_profile.label.bank_company_code')}
                        size="large"
                    />
                </Col>
                <Col span={12}>
                    <FormInput
                        fontWeight="bold"
                        vertical={true}
                        name="serviceCode"
                        label={
                            t("company_profile.label.product_code")
                        }
                        placeholder={t('company_profile.label.product_code')}
                        size="large"
                    />
                </Col>
            </Row>
        </Space>
    )
}
export default FinancialInformationForEdit;